import { compose } from 'recompose'
import { connect } from 'react-redux'

import { withTheme } from 'modules/util'
import { Argument, Builder } from '../../selectors'

import strongestTheme from './theme.scss'

function mapStateToProps(state, props) {
  const id = parseFloat(props.match.params.id)

  return {
    id,
    argument: {
      ...Argument.selected(id, state),
      parts: Builder.parts(state)
    }
  }
}

export default compose(connect(mapStateToProps), withTheme(strongestTheme))



// WEBPACK FOOTER //
// ./client/modules/debate/components/Strongest/enhancers.js